export const hardenabilityTemplate = [
  { header: 'generateReport.dataToResult.report.general.document_version' },
  { header: 'generateReport.dataToResult.report.general.id_ensaio' },
  { header: 'generateReport.dataToResult.report.general.id_hex' },
  { header: 'generateReport.dataToResult.report.general.product' },
  { header: 'generateReport.dataToResult.report.general.product_version' },
  { header: 'generateReport.dataToResult.report.general.date_started' },
  { header: 'generateReport.dataToResult.report.general.remark' },  
  { header: 'generateReport.dataToResult.report.general.text_comentario' },
  { header: 'generateReport.dataToResult.report.general.project' },
  { header: 'generateReport.dataToResult.report.general.planta_origem' },
  { header: 'generateReport.dataToResult.report.general.data_cadastro' },
  {
    header:
      'generateReport.dataToResult.report.general.data_liberacao_resultado',
  },
  { header: 'generateReport.dataToResult.report.general.amostra_mes' },
  { header: 'generateReport.dataToResult.report.general.desc_cliente' },
  { header: 'generateReport.dataToResult.report.general.descricao_mes' },
  { header: 'generateReport.dataToResult.report.general.firma_insp' },
  { header: 'generateReport.dataToResult.report.general.pedido' },
  { header: 'generateReport.dataToResult.report.general.item' },
  { header: 'generateReport.dataToResult.report.general.corrida' },
  { header: 'generateReport.dataToResult.report.general.ordem_de_processo' },
  { header: 'generateReport.dataToResult.report.general.lote_tt' },
  { header: 'generateReport.dataToResult.report.general.ippn' },
  { header: 'generateReport.dataToResult.report.general.posicao_amostra' },
  { header: 'generateReport.dataToResult.report.general.id_amostra' },

  { header: 'generateReport.dataToResult.report.test.hardenability.metodo' },
  { header: 'generateReport.dataToResult.report.test.hardenability.quadrante' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dext1' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dext2' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dext3' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dext4' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dextm' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dmei1' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dmei2' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dmei3' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dmei4' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dmeim' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dint1' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dint2' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dint3' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dint4' },
  { header: 'generateReport.dataToResult.report.test.hardenability.dintm' },
  {
    header:
      'generateReport.dataToResult.report.test.hardenability.dureza_minimo',
  },
]
